import { useEffect, useState } from 'react';
import { Switch } from 'src/components/ui/switch';
import { clsx } from 'clsx';

export const SwitchKBComponent = ({
  isFetching,
  disabled = false,
  defaultChecked,
  onCheckedChange = () => {},
}: {
  isFetching?: boolean;
  disabled?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}) => {
  const [checkedState, setCheckedState] = useState(defaultChecked);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    setCheckedState(defaultChecked);
  }, [defaultChecked]);

  const handleChange = (val: boolean) => {
    setCheckedState(val);
    onCheckedChange(val);
    setIsChanged(true);
  };

  useEffect(() => {
    if (!isFetching) {
      setIsChanged(false);
    }
  }, [isFetching]);

  return (
    <Switch
      disabled={disabled}
      checked={checkedState}
      defaultChecked={defaultChecked}
      className={clsx(isChanged && 'blur-sm animate-pulse pointer-events-none')}
      onCheckedChange={handleChange}
    />
  );
};
